import { EditIcon, Link, RemoveIcon, StyledFlex } from '@dreryk/react-components';

import { MedicalServiceRemoveAction } from '../../remove/MedicalServiceRemoveAction';
import { MedicalServiceRemoveConfirmationEventInterceptor } from '../../remove/MedicalServiceRemoveConfirmationEventInterceptor';
import { MedicalServiceName } from '../../shared/serviceName/name.types';
import { MedicalServiceUpdateModalOpener } from '../../update/MedicalServiceUpdateModalOpener';

type MedicalServiceUpdateLinkProps = {
   readonly medicalServiceId: number;
};

export const MedicalServiceUpdateLink = (props: MedicalServiceUpdateLinkProps): JSX.Element => {
   return (
      <MedicalServiceUpdateModalOpener medicalServiceId={props.medicalServiceId}>
         {({ openModal }) => <Link testId={'medicalServiceUpdate'} icon={<EditIcon />} onClick={openModal} />}
      </MedicalServiceUpdateModalOpener>
   );
};

type MedicalServiceRemoveLinkProps = {
   readonly medicalServiceId: number;
   readonly medicalServiceName: MedicalServiceName;
};

export const MedicalServiceRemoveLink = (props: MedicalServiceRemoveLinkProps): JSX.Element => {
   return (
      <MedicalServiceRemoveConfirmationEventInterceptor medicalServiceName={props.medicalServiceName}>
         <MedicalServiceRemoveAction medicalServiceId={props.medicalServiceId}>
            {({ removeMedicalService }) => (
               <Link testId={'medicalServiceRemove'} onClick={removeMedicalService} icon={<RemoveIcon />} />
            )}
         </MedicalServiceRemoveAction>
      </MedicalServiceRemoveConfirmationEventInterceptor>
   );
};

type MedicalServiceOptionsCellProps = {
   readonly medicalServiceId: number;
   readonly medicalServiceName: MedicalServiceName;
};

export const MedicalServiceOptionsCell = (props: MedicalServiceOptionsCellProps): JSX.Element => {
   return (
      <StyledFlex>
         <MedicalServiceUpdateLink medicalServiceId={props.medicalServiceId} />
         <MedicalServiceRemoveLink
            medicalServiceId={props.medicalServiceId}
            medicalServiceName={props.medicalServiceName}
         />
      </StyledFlex>
   );
};
